var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('h1',{staticClass:"formheader"},[_vm._v(_vm._s(_vm.title))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }